import { useReducedMotion } from 'framer-motion';

/**
 * Infinite horizontal marquee of quotes; motion-reduced users get a static grid.
 */
export function TestimonialsMarquee({ items }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
        {items.map((item) => (
          <figure
            key={item.name}
            className="relative rounded-2xl border border-stone-200/90 bg-white/80 px-6 py-6 md:px-8 md:py-7 shadow-sm"
          >
            <blockquote className="font-editorial text-lg md:text-xl text-stone-700 leading-snug mb-4">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <figcaption className="text-[11px] font-mono uppercase tracking-[0.16em] text-stone-500">
              <span className="text-stone-800 font-medium">{item.name}</span>
              {item.place ? <span className="text-stone-400"> · {item.place}</span> : null}
              {item.product ? <span className="block mt-1 text-stone-400 normal-case tracking-normal">{item.product}</span> : null}
            </figcaption>
          </figure>
        ))}
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden py-2 -mx-5 sm:-mx-8">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-[#f3f1ec] to-transparent z-10" aria-hidden />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-[#f3f1ec] to-transparent z-10" aria-hidden />
      <div className="flex w-max motion-safe:animate-promo-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 gap-6 md:gap-8 pr-6 md:pr-8" aria-hidden={dup === 1 ? true : undefined}>
            {items.map((item) => (
              <figure
                key={`${dup}-${item.name}-${item.place}`}
                className="relative w-[min(100vw-3rem,340px)] md:w-[380px] shrink-0 rounded-2xl border border-stone-200/90 bg-white/90 px-6 py-6 md:px-8 md:py-7 shadow-[0_8px_30px_-12px_rgba(28,27,25,0.12)]"
              >
                <blockquote className="font-editorial text-lg md:text-xl text-stone-700 leading-snug mb-4">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="text-[11px] font-mono uppercase tracking-[0.16em] text-stone-500">
                  <span className="text-stone-800 font-medium">{item.name}</span>
                  {item.place ? <span className="text-stone-400"> · {item.place}</span> : null}
                  {item.product ? (
                    <span className="block mt-1.5 text-stone-400 normal-case tracking-normal text-xs">{item.product}</span>
                  ) : null}
                </figcaption>
              </figure>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
